import React from 'react'
import BlessCollection from '../../components/BlessComp/BlessCollectionComp/BlessCollection'
import BlessContactForm from '../../components/BlessComp/BlessContactComp/BlessContactForm'
import BlessFooter from '../../components/BlessComp/BlessFooter/BlessFooter'
import BlessLandingPage from '../../components/BlessComp/BlessLandingComp/BlessLandingPage'
import BlessAbout from '../../components/BlessComp/BlessaboutComp/BlessAbout'

const BlesslayoutPage = () => {
  return (
    <div>
      <BlessLandingPage />
      <BlessAbout/>
        <BlessCollection />
        {/* <ContactForm /> */}
        <BlessContactForm />
        {/* <BlessCollectionList /> */}
        <BlessFooter />

    </div>
  )
}

export default BlesslayoutPage